import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

type FormWrapperProps = {
    title: string;
    children: ReactNode;
    text?: string;
    headerAction?: ReactNode;
};

export function EsFormWrapper({ title, children, text, headerAction }: FormWrapperProps) {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: '10px', mt: '8px' }}>
                <Typography
                    variant="h2"
                    style={{
                        flex: 1,
                        maxWidth: 400,
                        width: '100%',
                        textAlign: 'left',
                        fontSize: 20,
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '32px',
                        margin: 0,
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                    }}>
                    {title}
                </Typography>
                {headerAction}
            </Box>
            <Typography
                style={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 14,
                    fontStyle: 'normal',
                    fontWeight: '500',
                    color: theme[themeStyle].tag_white,
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                }}>
                {text}
            </Typography>
            {children}
        </Box>
    );
}
